import {
  Flex,
  IconButton,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import React from "react";
import { API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";
import WhitelistIpEditDialog from "./WhitelistIpEditDialog";

function WhitelistIpRow({ detail, isLast, refetch }) {
  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const toast = useToast();
  const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();

  async function handleDelete() {
    if (!window.confirm(`Xoá IP ${detail.ip}?`)) return;
    try {
      const res = await axiosPost(API_ROUTES.IpDelete, { id: detail._id });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Xoá thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Đã xoá",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      refetch?.();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Xoá thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }

  const created = detail.createdAt
    ? new Date(detail.createdAt).toLocaleString()
    : "-";

  return (
    <Tr>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="md" color={textColor} fontWeight="bold">
          {detail.ip}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color="gray.400">
          {detail.note || "-"}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color="gray.400">
          {created}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex gap="4px">
          <IconButton
            p={2}
            color="blue.400"
            bg="transparent"
            onClick={onEditOpen}
            aria-label="Sửa ghi chú"
            title="Sửa ghi chú"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            p={2}
            color="red.400"
            bg="transparent"
            onClick={handleDelete}
            aria-label="Xoá IP"
          >
            <DeleteIcon />
          </IconButton>
        </Flex>
      </Td>
      {isEditOpen && (
        <WhitelistIpEditDialog
          isOpen={isEditOpen}
          onClose={onEditClose}
          detail={detail}
          refetch={refetch}
        />
      )}
    </Tr>
  );
}

export default WhitelistIpRow;
